
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30939',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30939",
  "emoji-mart": "static-3.6",
  "feedback-schema": "static-1.55515",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8459",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11912",
  "I18n": "static-7.1694",
  "quartz": "static-1.7595",
  "quartz-config": "static-1.1373",
  "quartz-core": "static-1.6814",
  "react-dlb": "static-1.92",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.83",
  "reselect": "static-3.15",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1043",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55502",
  "feedback-utils": "static-1.55506",
  "forms-embed-utils-lib": "static-1.4884",
  "forms-utils-lib": "static-1.13254",
  "foundations-assets": "static-1.5306",
  "foundations-components": "static-1.8665",
  "foundations-theming": "static-1.4903",
  "hub-http": "static-1.6630",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12219",
  "icons": "static-2.699",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4196",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17154",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5628",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.513",
  "tinymce-plugins": "static-1.58418",
  "transmute": "static-2.97",
  "ui-images": "static-2.1269",
  "UIComponents": "static-3.8858",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3872",
  "quartz-webpack": "static-1.3819",
  "foundations-theming-specialty": "static-1.2619",
  "property-description-translator": "static-1.4241",
  "HeadJS": "static-2.813",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3570",
  "msw": "static-1.102",
  "msw-config": "static-1.21",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4729",
  "jasmine-runner": "static-1.6871",
  "opentelemetry-fe-types": "static-1-aeastham-default-document-load-user-interaction.5",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.898",
  "hubspotter-http": "static-1.4933",
  "mobile-manifest-mixins": "static-1.596",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1-aeastham-default-document-load-user-interaction.5",
  "quartz-auth": "static-1.1270",
  "quartz-head": "static-1.1260",
  "quartz-i18n": "static-1.1270",
  "quartz-routing": "static-1.1025",
  "quartz-test": "static-1.1270",
  "quartz-tracking": "static-1.974",
  "trellis-components": "static-1.2983",
  "ui-fonts": "static-1.1174",
  "usage-tracker-container": "static-1.7725",
  "usage-tracker-core": "static-1.7585",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.309",
  "conversations-skeleton-state": "static-1.7602",
  "reference-resolvers": "static-1.8598",
  "sanitize-text": "static-1.8577",
  "PatternValidationJS": "static-1.3307",
  "ReduxMessenger": "static-2.10792",
  "outpost": "static-1.4554",
  "rpc-client-utils": "static-1.5090",
  "sanitize": "static-1.4894",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4934",
  "floating-ui": "static-1.67",
  "hs-story-utils": "static-1.9846",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.92",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.2964",
  "bend-plugin-foundations-theming": "static-1.3386",
  "foundations-theming-base": "static-1.3888",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.366",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "ai-components-ui-library": "static-1.9932",
  "atom": "static-1.5498",
  "codemirror": "static-5.105",
  "content-assistance-lib": "static-1.8347",
  "ContentUtils": "static-1.69350",
  "data-token-picker": "static-1.17047",
  "file-manager-components": "static-1.24750",
  "FileManagerCore": "static-1.40249",
  "FileManagerLib": "static-1.40390",
  "frontend-preferences-client": "static-1.8339",
  "hub-http-contrib": "static-1.3449",
  "interframe": "static-3.5161",
  "layout-dnd-components": "static-1.13138",
  "layout-dnd-utils": "static-1.12113",
  "property-translator": "static-1.5800",
  "react-codemirror": "static-1.11061",
  "react-colorpicker": "static-2.10634",
  "reference-resolvers-lite": "static-1.8527",
  "rich-text-lib": "static-1.20475",
  "tinymce-data": "static-1.41389",
  "tinymce-themes": "static-1.57274",
  "ui-addon-emoji-picker": "static-1.10287",
  "ui-addon-sales-email": "static-1.5623",
  "ui-brand-identity-lib": "static-1.16805",
  "bender-build-tools": "static-1.3518",
  "opentelemetry-web": "static-1.20",
  "beacon-keepalive-queue": "static-1.121",
  "hub-http-shared-msw-handlers": "static-1.10815",
  "hubspotter-http-shared-msw-handlers": "static-1.10813",
  "usage-tracker-session-replay": "static-1.5421",
  "base-ui": "static-1.26",
  "react-day-picker": "static-1.14",
  "trellis-theming": "static-1.1405",
  "tanstack-virtual": "static-1.42",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.500",
  "chirp-fetch": "static-1.2322",
  "stylex-utils": "static-1.162",
  "chatspot-core": "static-1.23536",
  "copilot-toolkit": "static-1.12053",
  "customer-data-objects-ui-components": "static-1.13451",
  "data-fetching-client": "static-1.10068",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5179",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29513",
  "usage-tracker": "static-1.7735",
  "cms-field-types": "static-1.5233",
  "content-icons-ui": "static-1.2417",
  "integrations-lib": "static-1.17310",
  "customer-data-objects": "static-1.8114",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.2017",
  "apollo-link-hub-http": "static-2.5021",
  "apollo-stack-hubspot": "static-3.98",
  "graphql": "static-1.92",
  "immer": "static-1.104",
  "immerable": "static-1.4562",
  "poll-commands": "static-1.3895",
  "ui-addon-iframeable": "static-1.9498",
  "video-components-external": "static-1.12339",
  "video-data-lib": "static-1.35997",
  "breeze-artifacts-sdk": "static-1.697",
  "audio-components": "static-1.6495",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29981",
  "FileManagerImages": "static-1.37901",
  "foundations-components-legacy": "static-1.1690",
  "html-to-image": "static-1.64",
  "redux-toolkit": "static-1.81",
  "salesImages": "static-1.678",
  "ui-universal-auth": "static-1.9629",
  "urlinator": "static-1.4937",
  "video-components": "static-1.14341",
  "video-embed": "static-1.36831",
  "ts-schema": "static-1.4366",
  "ContentData": "static-1.69425",
  "layout-data-lib": "static-1.10438",
  "react-dnd-compat": "static-1.5031",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1967",
  "external-options-client-types": "static-1.4415",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6010",
  "hs-resources": "static-1.618",
  "inbound-db-properties-service-client": "static-1.4113",
  "NamespacedHubStyle": "static-2.9329",
  "growth-onboarding-confetti": "static-1.3484",
  "SharedI18nStrings": "static-1.186",
  "ui-addon-i18n": "static-1.11567",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5855",
  "magpie-types": "static-1.5315",
  "simple-logging-lib": "static-1.3472",
  "avatar-components": "static-1.2905",
  "customer-data-ui-utilities": "static-1.10254",
  "growth-onboarding-feedback-components": "static-1.7003",
  "flux-actions": "static-1.379",
  "hubspot-apollo-client": "static-1.5298",
  "integrations-error-boundary-lib": "static-1.14725",
  "integrations-tracking-lib": "static-1.6032",
  "laboratory-lib": "static-3.7571",
  "native-integrations-shared-strings": "static-1.8183",
  "redux-observable": "static-1.78",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10695",
  "unified-auth": "static-1.1143",
  "breeze-engine-chat-components": "static-1.995",
  "breeze-engine-core": "static-1.1295",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "pulse": "static-1.1061",
  "navigation-messaging": "static-1.8393",
  "content-media-composition-data-lib": "static-1.13490",
  "content-media-compositions": "static-2.17497",
  "idb-keyval": "static-1.54",
  "media-bridge-lib": "static-1.19562",
  "nudge-client-utils": "static-1.3327",
  "unified-auth-core-lib": "static-1.1425",
  "social-insights-client-types": "static-1.22846",
  "advanced-menus-core": "static-1.15735",
  "advanced-menus-lib": "static-1.12513",
  "ExportDialog": "static-6.10793",
  "ui-memberships-settings-lib": "static-1.35089",
  "conditional-properties-service-client": "static-1.4086",
  "crm-pipelines-api-client-types": "static-1.4417",
  "event-emitter": "static-1.1380",
  "framework-builder-read-service-client": "static-1.4293",
  "fdsr-migration-layer": "static-1.432",
  "inbound-db-meta-service-client": "static-1.3744",
  "multi-currency-client-types": "static-1.3982",
  "foundations-components-test-utils": "static-1.6148",
  "reactive-lib": "static-1.1144",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.757",
  "universal-page-editor-lib": "static-1.3430",
  "adobe-sign-auth-lib": "static-1.674",
  "ads-unified-auth-lib": "static-1.1778",
  "custom-vendor-connection-lib": "static-1.193",
  "google-sheets-integration-lib": "static-1.1239",
  "microsoft-drive-auth-lib": "static-1.401",
  "surveymonkey-integration-lib": "static-1.768",
  "slack-ui-library": "static-1.10818",
  "bend-plugin-pulse": "static-1.564",
  "fast-json-patch": "static-1.73",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3084",
  "nudge-renderer-utils": "static-1.3403",
  "onboarding-tours": "static-1.17308",
  "whisper-core-api": "static-1.7542",
  "fsm": "static-1.4175",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15734",
  "simple-menus-lib": "static-1.17251",
  "settings-ui-lib": "static-1.12951",
  "persist-promise": "static-1.4124",
  "crm-record-cards-service-types": "static-1.3834",
  "framework-data-schema-resolvers": "static-1.7313",
  "location-customization-utils-lib": "static-1.10327",
  "getting-started-shared-tasks": "static-1.19471",
  "growth-data-modal": "static-1.6056",
  "growth-onboarding-next-action-utils": "static-1.2895",
  "navigation-components": "static-1.19066",
  "onboarding-tours-client": "static-1.5523",
  "onboarding-tours-utils": "static-1.1375",
  "ui-shepherd-tracker": "static-1.8076",
  "user-context": "static-1.5479",
  "react-flip-move": "static-1.82",
  "framework-data-schema-quick-fetch": "static-1.7218",
  "onboarding-data-sync-lib": "static-1.2757",
  "growth-onboarding-next-action-components": "static-1.2923",
  "user-context-client": "static-1.4930",
  "nest": "static-1.656",
  "getting-started-shared-tasks-store": "static-1.18589",
  "InboxConnectUtils": "static-4.15755",
  "meetings-connect-utils-lib": "static-1.8037",
  "onboarding-scopes": "static-1.6873"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30939",
  "emoji-mart": "/emoji-mart/static-3.6",
  "feedback-schema": "/feedback-schema/static-1.55515",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8459",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11912",
  "I18n": "/I18n/static-7.1694",
  "quartz": "/quartz/static-1.7595",
  "quartz-config": "/quartz-config/static-1.1373",
  "quartz-core": "/quartz-core/static-1.6814",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.83",
  "reselect": "/reselect/static-3.15",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1043",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55502",
  "feedback-utils": "/feedback-utils/static-1.55506",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4884",
  "forms-utils-lib": "/forms-utils-lib/static-1.13254",
  "foundations-assets": "/foundations-assets/static-1.5306",
  "foundations-components": "/foundations-components/static-1.8665",
  "foundations-theming": "/foundations-theming/static-1.4903",
  "hub-http": "/hub-http/static-1.6630",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12219",
  "icons": "/icons/static-2.699",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4196",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17154",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5628",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.513",
  "tinymce-plugins": "/tinymce-plugins/static-1.58418",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1269",
  "UIComponents": "/UIComponents/static-3.8858",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3872",
  "quartz-webpack": "/quartz-webpack/static-1.3819",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2619",
  "property-description-translator": "/property-description-translator/static-1.4241",
  "HeadJS": "/HeadJS/static-2.813",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3570",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.21",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4729",
  "jasmine-runner": "/jasmine-runner/static-1.6871",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1-aeastham-default-document-load-user-interaction.5",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.898",
  "hubspotter-http": "/hubspotter-http/static-1.4933",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.596",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1-aeastham-default-document-load-user-interaction.5",
  "quartz-auth": "/quartz-auth/static-1.1270",
  "quartz-head": "/quartz-head/static-1.1260",
  "quartz-i18n": "/quartz-i18n/static-1.1270",
  "quartz-routing": "/quartz-routing/static-1.1025",
  "quartz-test": "/quartz-test/static-1.1270",
  "quartz-tracking": "/quartz-tracking/static-1.974",
  "trellis-components": "/trellis-components/static-1.2983",
  "ui-fonts": "/ui-fonts/static-1.1174",
  "usage-tracker-container": "/usage-tracker-container/static-1.7725",
  "usage-tracker-core": "/usage-tracker-core/static-1.7585",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.309",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "reference-resolvers": "/reference-resolvers/static-1.8598",
  "sanitize-text": "/sanitize-text/static-1.8577",
  "PatternValidationJS": "/PatternValidationJS/static-1.3307",
  "ReduxMessenger": "/ReduxMessenger/static-2.10792",
  "outpost": "/outpost/static-1.4554",
  "rpc-client-utils": "/rpc-client-utils/static-1.5090",
  "sanitize": "/sanitize/static-1.4894",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4934",
  "floating-ui": "/floating-ui/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9846",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.92",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.2964",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3386",
  "foundations-theming-base": "/foundations-theming-base/static-1.3888",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.366",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9932",
  "atom": "/atom/static-1.5498",
  "codemirror": "/codemirror/static-5.105",
  "content-assistance-lib": "/content-assistance-lib/static-1.8347",
  "ContentUtils": "/ContentUtils/static-1.69350",
  "data-token-picker": "/data-token-picker/static-1.17047",
  "file-manager-components": "/file-manager-components/static-1.24750",
  "FileManagerCore": "/FileManagerCore/static-1.40249",
  "FileManagerLib": "/FileManagerLib/static-1.40390",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8339",
  "hub-http-contrib": "/hub-http-contrib/static-1.3449",
  "interframe": "/interframe/static-3.5161",
  "layout-dnd-components": "/layout-dnd-components/static-1.13138",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12113",
  "property-translator": "/property-translator/static-1.5800",
  "react-codemirror": "/react-codemirror/static-1.11061",
  "react-colorpicker": "/react-colorpicker/static-2.10634",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8527",
  "rich-text-lib": "/rich-text-lib/static-1.20475",
  "tinymce-data": "/tinymce-data/static-1.41389",
  "tinymce-themes": "/tinymce-themes/static-1.57274",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10287",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5623",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16805",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "opentelemetry-web": "/opentelemetry-web/static-1.20",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.121",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10815",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10813",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5421",
  "base-ui": "/base-ui/static-1.26",
  "react-day-picker": "/react-day-picker/static-1.14",
  "trellis-theming": "/trellis-theming/static-1.1405",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.500",
  "chirp-fetch": "/chirp-fetch/static-1.2322",
  "stylex-utils": "/stylex-utils/static-1.162",
  "chatspot-core": "/chatspot-core/static-1.23536",
  "copilot-toolkit": "/copilot-toolkit/static-1.12053",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13451",
  "data-fetching-client": "/data-fetching-client/static-1.10068",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5179",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29513",
  "usage-tracker": "/usage-tracker/static-1.7735",
  "cms-field-types": "/cms-field-types/static-1.5233",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "integrations-lib": "/integrations-lib/static-1.17310",
  "customer-data-objects": "/customer-data-objects/static-1.8114",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2017",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5021",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
  "graphql": "/graphql/static-1.92",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4562",
  "poll-commands": "/poll-commands/static-1.3895",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9498",
  "video-components-external": "/video-components-external/static-1.12339",
  "video-data-lib": "/video-data-lib/static-1.35997",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.697",
  "audio-components": "/audio-components/static-1.6495",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29981",
  "FileManagerImages": "/FileManagerImages/static-1.37901",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1690",
  "html-to-image": "/html-to-image/static-1.64",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "salesImages": "/salesImages/static-1.678",
  "ui-universal-auth": "/ui-universal-auth/static-1.9629",
  "urlinator": "/urlinator/static-1.4937",
  "video-components": "/video-components/static-1.14341",
  "video-embed": "/video-embed/static-1.36831",
  "ts-schema": "/ts-schema/static-1.4366",
  "ContentData": "/ContentData/static-1.69425",
  "layout-data-lib": "/layout-data-lib/static-1.10438",
  "react-dnd-compat": "/react-dnd-compat/static-1.5031",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1967",
  "external-options-client-types": "/external-options-client-types/static-1.4415",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6010",
  "hs-resources": "/hs-resources/static-1.618",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4113",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9329",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3484",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11567",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5855",
  "magpie-types": "/magpie-types/static-1.5315",
  "simple-logging-lib": "/simple-logging-lib/static-1.3472",
  "avatar-components": "/avatar-components/static-1.2905",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10254",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7003",
  "flux-actions": "/flux-actions/static-1.379",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5298",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14725",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6032",
  "laboratory-lib": "/laboratory-lib/static-3.7571",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8183",
  "redux-observable": "/redux-observable/static-1.78",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10695",
  "unified-auth": "/unified-auth/static-1.1143",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.995",
  "breeze-engine-core": "/breeze-engine-core/static-1.1295",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "pulse": "/pulse/static-1.1061",
  "navigation-messaging": "/navigation-messaging/static-1.8393",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13490",
  "content-media-compositions": "/content-media-compositions/static-2.17497",
  "idb-keyval": "/idb-keyval/static-1.54",
  "media-bridge-lib": "/media-bridge-lib/static-1.19562",
  "nudge-client-utils": "/nudge-client-utils/static-1.3327",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1425",
  "social-insights-client-types": "/social-insights-client-types/static-1.22846",
  "advanced-menus-core": "/advanced-menus-core/static-1.15735",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12513",
  "ExportDialog": "/ExportDialog/static-6.10793",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35089",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4086",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4417",
  "event-emitter": "/event-emitter/static-1.1380",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4293",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.432",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3744",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3982",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6148",
  "reactive-lib": "/reactive-lib/static-1.1144",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.757",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3430",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.674",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1778",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.193",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1239",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.401",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.768",
  "slack-ui-library": "/slack-ui-library/static-1.10818",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.564",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3084",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3403",
  "onboarding-tours": "/onboarding-tours/static-1.17308",
  "whisper-core-api": "/whisper-core-api/static-1.7542",
  "fsm": "/fsm/static-1.4175",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15734",
  "simple-menus-lib": "/simple-menus-lib/static-1.17251",
  "settings-ui-lib": "/settings-ui-lib/static-1.12951",
  "persist-promise": "/persist-promise/static-1.4124",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3834",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7313",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10327",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19471",
  "growth-data-modal": "/growth-data-modal/static-1.6056",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2895",
  "navigation-components": "/navigation-components/static-1.19066",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5523",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1375",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8076",
  "user-context": "/user-context/static-1.5479",
  "react-flip-move": "/react-flip-move/static-1.82",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7218",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2757",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2923",
  "user-context-client": "/user-context-client/static-1.4930",
  "nest": "/nest/static-1.656",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18589",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15755",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8037",
  "onboarding-scopes": "/onboarding-scopes/static-1.6873"
}
};
